import React from 'react';
import { Globe, ChevronDown, User, LogOut, Menu, X } from 'lucide-react';
import { useAuth } from '@/domains/auth';
import { navigateTo } from '@/shared/utils/navigation';
import './NavbarActions.css';

export function NavbarActions({ mobileMenuOpen, onToggleMobileMenu }) {
  const { user, isAuthenticated, isLoading, logout } = useAuth();

  const handleLoginClick = (e) => {
    e.preventDefault();
    navigateTo('/login');
  };

  const displayName =
    user?.user_metadata?.name || user?.email?.split('@')[0] || '궁사';

  return (
    <div className="navbar-actions">
      <a
        href="mailto:aimus1440@gmail.com?subject=%5BAIMERS%5D%20%EC%A0%84%EB%AC%B8%20%ED%85%8C%EC%8A%A4%ED%84%B0%EB%8B%A8%20%EC%A7%80%EC%9B%90"
        className="navbar-actions__recruit-link"
      >
        AIMERS 전문 테스터단 모집!
      </a>

      <button type="button" className="navbar-actions__lang-btn">
        <Globe size={15} />
        <span>한국어</span>
        <ChevronDown size={12} />
      </button>

      {isAuthenticated ? (
        <div className="navbar-actions__user-box">
          <span className="navbar-actions__user-name">{displayName} 님</span>
          <button
            type="button"
            className="navbar-actions__logout-btn"
            onClick={logout}
            title="로그아웃"
          >
            <LogOut size={15} />
            <span>로그아웃</span>
          </button>
        </div>
      ) : (
        <a
          href="/login"
          className="navbar-actions__login-btn"
          onClick={handleLoginClick}
          aria-disabled={isLoading}
        >
          <User size={15} />
          <span>로그인</span>
        </a>
      )}

      {onToggleMobileMenu && (
        <button
          type="button"
          className="navbar-actions__toggle-btn"
          onClick={onToggleMobileMenu}
          aria-label={mobileMenuOpen ? '메뉴 닫기' : '메뉴 열기'}
          aria-expanded={mobileMenuOpen}
        >
          {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      )}
    </div>
  );
}
